var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknownUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5z",
    fill: "#90a4ae"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 20c-.414 0-.75-.336-.75-.75 0-1.098.331-2.017 1.327-2.782.265-.203.423-.534.423-.884 0-.598-.449-1.083-1-1.083s-1 .486-1 1.083c0 .414-.336.75-.75.75s-.75-.336-.75-.751c0-1.424 1.122-2.583 2.5-2.583s2.5 1.159 2.5 2.583c0 .813-.377 1.589-1.009 2.074-.654.502-.741.965-.741 1.592 0 .415-.336.751-.75.751z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 21.251,
    fill: "#fff",
    r: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.4 6.08c-1.16 0-2.02-.7-2.53-1.26-1.89 1.34-4.66 1.27-5.32 1.21-.01 0-.01 0-.02 0 .27 2.23 2.17 3.97 4.47 3.97 2.31 0 4.22-1.75 4.47-4-.22.04-.55.08-1.07.08z",
    fill: "#90a4ae"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 5.5c0 .17-.01.34-.03.5-.22.04-.55.08-1.07.08-1.16 0-2.02-.7-2.53-1.26-1.89 1.34-4.66 1.27-5.32 1.21-.01 0-.01 0-.02 0-.02-.17-.03-.35-.03-.53 0-.33.04-.66.11-.97.44-2.02 2.24-3.53 4.39-3.53 2.16 0 3.97 1.53 4.4 3.56.07.3.1.62.1.94z",
    fill: "#455a64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m11.706 12h-7.956c-2.068 0-3.75 1.682-3.75 3.75v3.5c0 .414.336.75.75.75h9.156c-.938-2.839-.216-5.877 1.8-8z",
    fill: "#90a4ae"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 17.01c-.552.647-.75 1.39-.75 2.24 0 .414.336.75.75.75zm0-4.01c-1.379 0-2.5 1.159-2.5 2.583 0 .414.336.75.75.75s.75-.336.75-.75c0-.598.449-1.083 1-1.083z",
    fill: "#dedede"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 20.5c-.414 0-.75.336-.75.75 0 .415.336.75.75.75z",
    fill: "#dedede"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m8 5.327c-.479.225-.974.378-1.477.482-.876.198-1.711.247-2.296.247-.302 0-.537-.013-.678-.026h-.019c.27 2.23 2.17 3.97 4.47 3.97z",
    fill: "#7d8f97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m8 1.053c-2.428.035-4.854 1.713-4.47 4.977.98 0 2.001-.015 2.993-.221.503-.104.998-.257 1.477-.482z",
    fill: "#3c4e57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7d8f97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 12h-4.25c-2.068 0-3.75 1.682-3.75 3.75v3.5c0 .414.336.75.75.75h7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 11c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5v-1.999c-.414 0-.75-.335-.75-.75 0-.414.336-.75.75-.75v-.501c-.414 0-.75-.336-.75-.75 0-.85.198-1.593.75-2.24v-2.51c-.551 0-1 .486-1 1.083 0 .414-.336.75-.75.75s-.75-.335-.75-.75c0-1.424 1.121-2.583 2.5-2.583z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownUser);
export default __webpack_public_path__ + "static/media/unknown-user.6f30f1a0038f838b1cefc4ac2d322023.svg";
export { ForwardRef as ReactComponent };